import * as React from 'react';
import * as styles from './styles.css';
import { Suggest } from './components/Suggest';
import { ILocation } from '../../types/location';
import { Search16 } from '@cian/ui-kit/icons/16/search';
import { FormInputsLayout } from '../FormInputsLayout';

export interface ILocationSuggestProps {
  inputValue: string;
  suggest: ILocation[];
  isSuggestShown: boolean;
  placeholder: string;
  isLoading: boolean;

  onChange(value: string): void;

  onItemClick(value: ILocation): void;
}

export const LocationSuggest: React.FC<ILocationSuggestProps> = ({
  onChange,
  inputValue,
  suggest,
  onItemClick,
  isSuggestShown,
  placeholder,
  isLoading,
}) => {
  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value), [
    onChange,
  ]);

  return (
    <div className={styles['container']} data-testid="location-suggest">
      <div className={styles['input-container']}>
        <FormInputsLayout
          InputProps={{
            loading: isLoading,
            placeholder,
            value: inputValue,
            onChange: handleChange,
            leftEnhancer: <Search16 color="black_100" />,
          }}
          fullwidth
        />
      </div>
      {isSuggestShown && <Suggest suggest={suggest} onItemClick={onItemClick} />}
    </div>
  );
};

LocationSuggest.displayName = 'LocationSuggest';
